var _linearGradient;

var _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import * as React from "react";

function SvgPhoto(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 800.00001 800.00001",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "c",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 652.36,
    r: 400,
    color: "#000000",
    colorRendering: "auto",
    fill: "#fff",
    imageRendering: "auto",
    shapeRendering: "auto",
    "solid-color": "#000000",
    style: {
      isolation: "auto",
      mixBlendMode: "normal"
    }
  })), /*#__PURE__*/React.createElement("mask", {
    id: "b",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 652.36,
    r: 400,
    color: "#000000",
    colorRendering: "auto",
    fill: "#fff",
    imageRendering: "auto",
    shapeRendering: "auto",
    "solid-color": "#000000",
    style: {
      isolation: "auto",
      mixBlendMode: "normal"
    }
  })), /*#__PURE__*/React.createElement("mask", {
    id: "a",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 400,
    r: 400,
    color: "#000000",
    colorRendering: "auto",
    fill: "#fff",
    imageRendering: "auto",
    shapeRendering: "auto",
    "solid-color": "#000000",
    style: {
      isolation: "auto",
      mixBlendMode: "normal"
    }
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 462.46,
    x2: 97.149,
    y1: 314.31,
    y2: 665.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0,
    offset: 1
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -252.36)",
    shapeRendering: "auto"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 652.36,
    r: 400,
    color: "#000000",
    colorRendering: "auto",
    fill: "#1c8adb",
    imageRendering: "auto",
    "solid-color": "#000000",
    style: {
      isolation: "auto",
      mixBlendMode: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(0 252.36)",
    d: "m157.4 224.34c-7.079 0-13.395 3.1345-17.656 8.0918l-139.44 139.44c-8.6956 372.5 157.81 431.29 404.67 428.11l252.79-252.79c4.9572-4.2598 8.0918-10.575 8.0918-17.654v-281.93c0-12.889-10.376-23.266-23.266-23.266z",
    color: "#000000",
    colorRendering: "auto",
    fill: "url(#d)",
    imageRendering: "auto",
    mask: "url(#a)",
    opacity: 0.42,
    "solid-color": "#000000",
    style: {
      isolation: "auto",
      mixBlendMode: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m157.4 476.71c-12.889 0-23.267 10.376-23.267 23.265v281.93c0 12.889 10.378 23.265 23.267 23.265h485.2c12.889 0 23.265-10.376 23.265-23.265v-281.93c0-12.889-10.376-23.265-23.265-23.265h-485.2zm385.66 23.248h79.878c9.5771 0 17.287 7.7098 17.287 17.287 0 9.5771-7.7098 17.289-17.287 17.289h-79.878c-9.5771 0-17.287-7.7119-17.287-17.289s7.7097-17.287 17.287-17.287zm-142.47 5.3644a134.72 134.72 0 0 1 134.72 134.72 134.72 134.72 0 0 1 -134.72 134.72 134.72 134.72 0 0 1 -134.72 -134.72 134.72 134.72 0 0 1 134.72 -134.72z",
    color: "#000000",
    colorRendering: "auto",
    fill: "#fff",
    imageRendering: "auto",
    mask: "url(#b)",
    "solid-color": "#000000",
    style: {
      isolation: "auto",
      mixBlendMode: "normal"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 400.6,
    cy: 640.04,
    r: 84.051,
    color: "#000000",
    colorRendering: "auto",
    fill: "#fff",
    imageRendering: "auto",
    mask: "url(#c)",
    "solid-color": "#000000",
    style: {
      isolation: "auto",
      mixBlendMode: "normal"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoto);
export default __webpack_public_path__ + "static/media/photo.b4a3453e00e171155d24b9c7d07932a9.svg";
export { ForwardRef as ReactComponent };